async function login(authType) {}

async function getToken(callbackState, code) {}

async function refresh(refreshToken) {}

const name = 'adminImpersonation';

export { login, getToken, refresh, name };
